import { render, staticRenderFns } from "./vantCountDown.vue?vue&type=template&id=51b6e7ca&scoped=true"
import script from "./vantCountDown.vue?vue&type=script&lang=js"
export * from "./vantCountDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b6e7ca",
  null
  
)

export default component.exports